import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { DemandeResurmeDTO } from "src/app/suivi-portefeuille/core/model/resurme/demande-resurme-dto";

@Component({
  selector: "app-dossier-info-tab",
  templateUrl: "./dossier-info-tab.component.html",
  styleUrls: ["./dossier-info-tab.component.scss"],
})
export class DossierInfoTabComponent implements OnInit {
  numDossier: number;
  demandeResurmeDTO: DemandeResurmeDTO;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private _requestService: RequestService
  ) {}

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.numDossier = params["numDossier"];
      this.findResurmerDemandeByRefCoreBanking(this.numDossier);
    });
  }

  findResurmerDemandeByRefCoreBanking(numDossier) {
    this._requestService
      .findResurmerDemandeByRefCoreBanking(numDossier)
      .subscribe(
        (data) => {
          this.demandeResurmeDTO = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }
}
